import { FC } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import { ACKNOWLEDGMENT_STATUS_DIALOG_TRANSLATION_KEYS } from '../translations'

import styles from './AcknowledgmentFooter.module.scss'

type AcknowledgmentFooterProps = {
  signedCount: number
  totalCount: number
  isSubmitting: boolean
  /** Left out where the host owns the way back, e.g. the embedded panel. */
  onClose?: () => void
}

export const AcknowledgmentFooter: FC<AcknowledgmentFooterProps> = ({
  signedCount,
  totalCount,
  isSubmitting,
  onClose,
}) => (
  <div className={styles.footer}>
    <div className={styles.footerSummary}>
      <Translation
        span
        text={ACKNOWLEDGMENT_STATUS_DIALOG_TRANSLATION_KEYS.footer.summary}
        replaceParams={[
          { key: '{signedCount}', value: String(signedCount) },
          { key: '{totalCount}', value: String(totalCount) },
        ]}
      />
    </div>

    {onClose && (
      <div className={styles.footerActions}>
        <Button className={styles.closeButton} size="sm" disabled={isSubmitting} onClick={onClose}>
          <Translation text={ACKNOWLEDGMENT_STATUS_DIALOG_TRANSLATION_KEYS.common.close} span />
        </Button>
      </div>
    )}
  </div>
)
